import React from 'react';
import StudioContent from './components/StudioContent';
import StudioContextStore from './components/StudioContextStore';
import StudioEditorProvider from './components/StudioEditorProvider';
import { withPageByolWatermark } from 'venn-components';
import { StudioPageLoadingState } from './components/StudioPageLoadingState';

// TODO(VENN-24534): add a display name to this React component
// eslint-disable-next-line react/display-name
const StudioPage = React.memo(() => {
  return (
    <StudioContextStore>
      <StudioEditorProvider>
        <React.Suspense fallback={<StudioPageLoadingState />}>
          <StudioContent />
        </React.Suspense>
      </StudioEditorProvider>
    </StudioContextStore>
  );
});

export default withPageByolWatermark(StudioPage);
